import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { pickErrorMessage } from '../lib/apiHelpers';
import { BrandLogo } from '../components/BrandLogo';
import { branding } from '../config/branding';
import { ErrorBanner } from '../components/PageChrome';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/';

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      await login(email, password);
      navigate(from, { replace: true });
    } catch (err) {
      setError(pickErrorMessage(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light p-3">
      <div className="card shadow border-0" style={{ maxWidth: 520, width: '100%' }}>
        <div className="card-body p-4 p-md-5">
          <div className="d-flex align-items-center gap-2 mb-4">
            <BrandLogo />
            <div>
              <h1 className="h4 mb-0">{branding.loginTitle}</h1>
              <p className="text-secondary small mb-0">{branding.loginSubtitle}</p>
            </div>
          </div>
          <ErrorBanner message={error} />
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="email" className="form-label">Email</label>
              <input id="email" type="email" className="form-control" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required />
            </div>
            <div className="mb-3">
              <label htmlFor="password" className="form-label">Password</label>
              <input id="password" type="password" className="form-control" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required />
            </div>
            <button type="submit" className="btn btn-primary w-100 mb-3" disabled={busy}>
              {busy ? 'Signing in…' : 'Sign in as Super Admin'}
            </button>
            <div className="text-center small text-secondary">
              Brand account? <Link to="/brand/login">Brand portal login</Link>
            </div>
            <div className="text-center mt-2">
              <Link to="/forgot-password" className="small">Forgot password?</Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
